Modules.EmailSubscription.Application = require('../../email_subscription/frontend/application');

Modules.Occasions.Application = (function() {
  function Application() {}

  Application.prototype.initialize = function() {
    var ref;
    if ((ref = Groupon.EmailSubscription) != null ? ref.enableCouponsEmailAlerts : void 0) {
      return Modules.EmailSubscription.Application.initializeCouponsEmailAlerts();
    }
  };

  return Application;

})();

module.exports = Modules.Occasions.Application;

